import React, { useContext, useEffect, useState } from "react";
import { multiStepContext } from "./ContextApiComponent";
import { Form, Row, Col } from "react-bootstrap";
import "../styles/RegistrationStyle.css";
import {
  validatePasswordsMatch,
  validateRequiredFields,
  validatePassword,
} from "./ValidationComponent";
import ".././.././../styles/CommonStyles.css";
import { useNavigate } from "react-router-dom";
import strings from "../../../utils/Strings";
import { RegistrationRequest } from "../data/request/RegistrationRequest";
import { RegistrationResponse } from "../data/response/RegistrationResponse";
import RegistrationClient from "../data/api/RegistrationClient";
import { useApi } from "../../../service/ApiContext";
import Logger from "../../../utils/Logger";
import GenericModal from "../../../components/GenericModalComponent";
import Loader from "../../../utils/Utils";
import { useAlert } from "../../../components/AlertContextComponent";
import { logActionEvent } from "../../../analytics/analytics_utils";
import { VerificationRequest } from "../data/request/VerificationRequest";
import { VerificationResponse } from "../data/response/VerificationResponse";
import downarrow from "../../../assets/images/downarrow.svg";
import uparrow from "../../../assets/images/uparrow.svg";
import { flushSync } from "react-dom";

const requiredFields = ["password", "confirmPassword"];

const ThirdStep: React.FC = () => {
  const api = useApi();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { setCurrentStep, userData, setUserData, currentStep, submitData } =
    useContext(multiStepContext)!;
  const [errors, setErrors] = useState<any>({});
  const [passerrors, setPassErrors] = useState("");
  const [passwordVisible, setPasswordVisible] = useState<boolean>(false);

  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modalTitle, setModalTitle] = useState<string>("");
  const [modalContent, setModalContent] = useState<React.ReactNode>(""); // Change to ReactNode

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  //   Loader.showLoading("Loading...");
  //   const param: VerificationRequest = {
  //     email_address: userData["corporateEmail"],
  //     entity: "USER",
  //   };
  //   try {
  //     const response = await api
  //       .post<VerificationResponse>(RegistrationClient.emailValidation, param)
  //       .then((res) => {
  //         if (res.data.error === null) {
  //           showAlert({
  //             show: true,
  //             title: "Info",
  //             message: res.data.detail,
  //             button1Text: "Cancel",
  //             alertType: "success",
  //             onlyNeedOneButton: true,
  //             btn1onPressed: () => setCurrentStep(currentStep + 1),
  //           });
  //         } else {
  //           showAlert({
  //             show: true,
  //             title: "Already Exist",
  //             message: res.data.error,
  //             button1Text: "Cancel",
  //             alertType: "success",
  //             onlyNeedOneButton: true,
  //             btn1onPressed: () => navigate(strings.routing.signupPage),
  //           });
  //         }
  //         Logger.info("response", res.data);
  //       })
  //       .catch((error) => {
  //         Logger.info("error response", error);
  //       });
  //   } catch (error) {
  //     Logger.info("error response", error);
  //   } finally {
  //     Loader.dismissLoading();
  //   }
  // };

  // const handleSubmit = () => {
  //   let checkError: { [key: string]: string } = {};

  //   const requiredErrors = validateRequiredFields(requiredFields, userData);
  //   if (Object.keys(requiredErrors).length > 0) {
  //     checkError = { ...checkError, ...requiredErrors };
  //   }

  //   const passwordError = validatePassword(userData["password"]);
  //   const confirmPasswordError=validatePassword(userData["confirmPassword"])
  //   if (passwordError) {
  //     checkError["password"] = passwordError;
  //     checkError["confirmPassword"]=confirmPasswordError

  //   }

  //   // const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,16}$/;
  //   const passwordRegex =
  //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])[^\s]{8,16}$/; // This now explicitly disallows spaces

  //   if (!passwordRegex.test(userData["password"])) {
  //     checkError["passwordLength"] =
  //       "Password should have a minimum length of 8 and a maximum length of 16 characters, contain at least one uppercase, one lowercase, one digit, one special character and should not contain any spaces.";
  //   }

  //   if (!passwordRegex.test(userData["confirmPassword"])) {
  //     checkError["passwordLength"] =
  //       "Password should have a minimum length of 8 and a maximum length of 16 characters, contain at least one uppercase, one lowercase, one digit, one special character and should not contain any spaces.";
  //   }

  //   if (
  //     !validatePasswordsMatch(userData["password"], userData["confirmPassword"])
  //   ) {
  //     checkError["confirmPassword"] =
  //       "Password and confirm password does not match";
  //   }

  //   if (Object.keys(checkError).length > 0) {
  //     setErrors(checkError);

  //     return;
  //   } else {
  //     setCurrentStep(currentStep + 1);
  //     showAlert({
  //       show: true,
  //       title: "Info",
  //       message: "Verification Code Sent Successfully",
  //       button1Text: "Cancel",
  //       alertType: "success",
  //       onlyNeedOneButton: true,
  //       btn1onPressed: () => setCurrentStep(currentStep + 1),
  //     });
  //   }
  // };

  const handleSubmit = () => {
    let checkError: { [key: string]: string } = {};
    let showPasswordRegexError = true; // Flag to show regex error only if no other errors exist

    const requiredErrors = validateRequiredFields(requiredFields, userData);
    if (Object.keys(requiredErrors).length > 0) {
      checkError = { ...checkError, ...requiredErrors };
    }

    const passwordError = validatePassword(userData["password"]);
    const confirmPasswordError = validatePassword(userData["confirmPassword"]);

    // If there's a space error or empty password error, add it to checkError
    if (passwordError) {
      checkError["password"] = passwordError;
      showPasswordRegexError = false; // Don't show regex error if there's a space/empty error
    }
    if (confirmPasswordError) {
      checkError["confirmPassword"] = confirmPasswordError;
      showPasswordRegexError = false; // Don't show regex error if there's a space/empty error
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])[^\s]{8,16}$/;

    // If password does not match regex and there are no space/mismatch errors, set regex error
    if (
      !passwordRegex.test(userData["password"]) ||
      !passwordRegex.test(userData["confirmPassword"])
    ) {
      if (showPasswordRegexError) {
        checkError["passwordRegex"] =
          "Password should have a minimum length of 8 and a maximum length of 16 characters, contain at least one uppercase, one lowercase, one digit, one special character, and should not contain any spaces.";
      }
    }

    // Check for mismatch error only if no other errors exist
    if (
      Object.keys(checkError).length === 0 &&
      !validatePasswordsMatch(userData["password"], userData["confirmPassword"])
    ) {
      checkError["confirmPassword"] =
        "Password and confirm password do not match";
      showPasswordRegexError = false; // Don't show regex error if there's a mismatch error
    }

    // Set errors
    setErrors(checkError);

    // If there are any errors, return
    if (Object.keys(checkError).length > 0) {
      return;
    } else {
      setCurrentStep(currentStep + 1);
      showAlert({
        show: true,
        title: "Info",
        message: "Verification Code Sent Successfully",
        button1Text: "Cancel",
        alertType: "info",
        onlyNeedOneButton: true,
        btn1onPressed: () => setCurrentStep(currentStep + 1),
      });
    }
  };

  // State to track the active section by its index
  const [activeSection, setActiveSection] = useState<number | undefined>(0);

  // // Function to toggle the section
  // const toggleSection = (index: number) => {
  //   Logger.info(`Toggle section: ${index}`);
  //   setActiveSection((prev) => (prev === index ? undefined : index));
  // };

  useEffect(() => {
    if (modalShow && activeSection !== undefined) {
      handleShowModal(strings.modal.privacy); // or another relevant condition
    }
  }, [activeSection, modalShow]);
  const PrivacyModalContent = ({ sections }: { sections: any[] }) => {
    const [activeSection, setActiveSection] = useState(0);

    return (
      <div style={{ display: "flex", fontFamily: "Mazzard", height: "45vh" }}>
        {/* Questions Sidebar */}
        <div
          style={{
            width: "50%",
            paddingRight: "20px",
            height: "100%",
            overflowY: "hidden",
          }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", height: "80vh" }}
          >
            {sections.map((section, index) => (
              <button
                key={index}
                onClick={() => setActiveSection(index)}
                style={{
                  textAlign: "left",
                  padding: "12px", // Slightly more vertical padding
                  marginBottom: "5px",
                  lineHeight: "25px",
                  backgroundColor:
                    activeSection === index ? "#083454" : "white",
                  border: "none",
                  cursor: "pointer",
                  borderRadius: "4px",
                  fontSize: "16px",
                  fontWeight: activeSection === index ? "500" : "500",
                  color: activeSection === index ? "white" : "black",
                  fontFamily: "Mazzard",
                }}
              >
                {section.title}
              </button>
            ))}
          </div>
        </div>

        {/* Content Area */}
        <div
          style={{
            width: "50%",
            // padding: "0 20px",
            overflowY: "auto", // Only this area scrolls
            height: "85%", // Take full height of parent

            /* For Firefox */
            scrollbarWidth: "inherit",
            scrollbarColor: "rgba(0,0,0,0.2) transparent",

            /* For WebKit browsers - requires a style tag workaround */
            position: "relative",
          }}
        >
          <div
            style={{
              lineHeight: "24px",
              fontSize: "16px",
              paddingRight: "10px",
            }}
          >
            {sections[activeSection]?.content}
          </div>
        </div>
      </div>
    );
  };
  // Array of sections with titles and content
  const sections = [
    {
      title: "How is personal information used for communications?",
      content: (
        <p>
          We may contact you periodically by e-mail, mail or telephone to
          provide information regarding programs, products, services and content
          that may be of interest to you. In addition, some of the features on
          this web site allow you to communicate with us using an online form.
          <br></br>
          <br></br>
          If your communication requests a response from us, we may send you a
          response via e-mail. The e-mail response or confirmation may include
          your personal information. We cannot guarantee that our e-mails to you
          will be secure from unauthorized interception.
        </p>
      ),
    },
    {
      title:
        "How can a user access, change, and/or delete personal information?",
      content: (
        <p>
          You may access, correct, update, and/or delete any
          personally-identifiable information that you submit to the website.
          You may also unsubscribe from mailing lists or any registrations on
          the web site. To do so, please drop an email to Sales.
          support@jozuna.com.
        </p>
      ),
    },
    {
      title: "How does JOZUNA use personal information?",
      content: (
        <p>
          Jozuna LLC may keep and use personal information we collect from or
          about you to provide you with access to this web site or other
          products or services, to respond to your requests, to bill you for
          products/services you purchased, and to provide ongoing service and
          support, to contact you with information that might be of interest to
          you, including information about products and services of ours and of
          others, or ask for your opinion about our products or the products of
          others, for record keeping and analytical purposes and to research,
          develop and improve programs, products, services and content. Personal
          information collected online may be combined with information you
          provide to us through other sources We may also remove your personal
          identifiers (your name, email address, social security number, etc).
          In this case, you would no longer be identified as a single unique
          individual. Once we have de-identified information, it is non-personal
          information and we may treat it like other non-personal information.
          Finally, we may use your personal information to protect our rights or
          property, or to protect someone’s health, safety or welfare, and to
          comply with a law or regulation, court order or other legal process.
        </p>
      ),
    },
    {
      title: "Does JOZUNA share personal information with others?",
      content: (
        <p>
          We will not share your personal information collected from this web
          site with an unrelated third party without your permission, except as
          otherwise provided in this Privacy Policy. In the ordinary course of
          business, we may share some personal information with companies that
          we hire to perform services or functions on our behalf. In all cases
          in which we share your personal information with a third party for the
          purpose of providing a service to us, we will not authorize them to
          keep, disclose or use your information with others except for the
          purpose of providing the services we asked them to provide. We will
          not sell, exchange or publish your personal information, except in
          conjunction with a corporate sale, merger, dissolution, or
          acquisition. For some sorts of transactions, in addition to our direct
          collection of information, our third party service vendors (such as
          credit card companies, clearinghouses and banks) who may provide such
          services as credit, insurance, and escrow services may collect
          personal information directly from you to assist you with your
          transaction. We do not control how these third parties use such
          information, but we do ask them to disclose how they use your personal
          information before they collect it. If you submit a review for a third
          party (person or business) using our Facebook Fan Review Application,
          during the submission process we ask your permission to gather your
          basic information (such as name and email address) which we then share
          with the third party for whom you are submitting the review. We may be
          legally compelled to release your personal information in response to
          a court order, subpoena, search warrant, law or regulation. We may
          cooperate with law enforcement authorities in investigating and
          prosecuting web site visitors who violate our rules or engage in
          behavior, which is harmful to other visitors (or illegal). We may
          disclose your personal information to third parties if we feel that
          the disclosure is necessary to protect our rights or property, protect
          someone’s health, safety or welfare, or to comply with a law or
          regulation, court order or other legal process. As discussed in the
          section on cookies and other technologies, from time to time we may
          allow a third party to serve advertisements on this website. If you
          share information with the advertiser, including by clicking on their
          ads, this Privacy Policy does not control the advertisers use of your
          personal information, and you should check the privacy policies of
          those advertisers and/or ad services to learn about their use of
          cookies and other technology before linking to an ad.
        </p>
      ),
    },
  ];

  const handleClose = () => {
    setModalShow(false);
    setActiveSection(undefined);
  };

  const handleShowModal = (title: string) => {
    setModalTitle(title);
    if (title === strings.modal.Terms) {
      setModalContent(
        <div>
          <ul>
            <li>
              The assessment is only used to develop and mature the platform and
              not for anyone's consumption.
            </li>
            <li>
              The data collected will be used to build and enhance our platform.
            </li>
            <li>
              The email information for the user is used only to send the
              assessment report and not for any marketing purpose at this point
              in time.
            </li>
            <li>
              The user can unsubscribe from the assessment report at any time by
              clicking the "Unsubscribe" button.
            </li>
          </ul>
        </div>,
      );
    } else if (title === strings.modal.privacy) {
      setModalContent(<PrivacyModalContent sections={sections} />);

      // setModalContent(
      //   <div
      //     style={{
      //       display: "flex",
      //       fontFamily: "Mazzard",
      //       height: "45vh", // Use viewport height percentage instead of 100vh
      //     }}
      //   >
      //     {/* Questions Sidebar - Fixed height */}
      //     <div
      //       style={{
      //         width: "50%",
      //         paddingRight: "20px",
      //         overflowY: "hidden", // Scrollable only if content exceeds height
      //         height: "100%", // Take full height of parent
      //       }}
      //     >
      //       <div
      //         style={{
      //           display: "flex",
      //           flexDirection: "column",
      //           height: "80vh", // Use viewport height percentage instead of 100vh
      //         }}
      //       >
      //         {sections.map((section, index) => (
      //           <button
      //             key={index}
      //             onClick={() => setActiveSection(index)}
      //             style={{
      //               textAlign: "left",
      //               padding: "12px", // Slightly more vertical padding
      //               marginBottom: "5px",
      //               lineHeight: "25px",
      //               backgroundColor:
      //                 activeSection === index ? "#083454" : "white",
      //               border: "none",
      //               cursor: "pointer",
      //               borderRadius: "4px",
      //               fontSize: "16px",
      //               fontWeight: activeSection === index ? "500" : "500",
      //               color: activeSection === index ? "white" : "black",
      //               fontFamily: "Mazzard",
      //             }}
      //           >
      //             {section.title}
      //           </button>
      //         ))}
      //       </div>
      //     </div>

      //     {/* Content Area - Scrollable */}
      //     <div
      //       style={{
      //         width: "50%",
      //         // padding: "0 20px",
      //         overflowY: "auto", // Only this area scrolls
      //         height: "85%", // Take full height of parent

      //         /* For Firefox */
      //         scrollbarWidth: "inherit",
      //         scrollbarColor: "rgba(0,0,0,0.2) transparent",

      //         /* For WebKit browsers - requires a style tag workaround */
      //         position: "relative",
      //       }}
      //     >
      //       <div
      //         style={{
      //           lineHeight: "24px",
      //           fontSize: "16px",
      //           fontFamily: "Mazzard",
      //           paddingRight: "10px", // Space for scrollbar
      //           color: "#333333",
      //         }}
      //       >
      //         {sections[activeSection!].content}
      //       </div>
      //     </div>
      //   </div>
      // );
      // setModalContent(
      //   <div>
      //     {sections.map((section, index) => (
      //       <div key={index} style={{ paddingBottom: "10px" }}>
      //         <h5
      //           onClick={() => toggleSection(index)}
      //           style={{
      //             fontFamily: "Mazzard",
      //             cursor: "pointer",
      //             fontSize: "16px",
      //             fontWeight: "700",
      //             color: "#333333",
      //             width: "100%",
      //           }}
      //         >
      //           {section.title}{" "}
      //           <img
      //             src={activeSection === index ? uparrow : downarrow}
      //             alt={activeSection === index ? "Collapse" : "Expand"}
      //             style={{
      //               width: "16px",
      //               height: "16px",
      //               verticalAlign: "middle",
      //             }}
      //           />{" "}
      //         </h5>
      //         {activeSection === index && <div>{section.content}</div>}
      //       </div>
      //     ))}
      //   </div>
      // );
    }

    setModalShow(true);
  };

  return (
    <div className="FormStep" style={{justifyContent:"space-between",display:"flex",flexDirection:"column",height:"55vh"}}>
     <div> <div className="form-input">
        <Row className="custom-row">
          <Col md={6}>
            <Form.Label htmlFor="password">Password*</Form.Label>
            <Form.Control
              className="rounded-input"
              type={passwordVisible ? "text" : "password"}
              id="password"
              value={userData["password"]}
              onChange={(e) =>
                setUserData({ ...userData, password: e.target.value })
              }
            />
            {errors.password && (
              <div className="error-message">{errors.password}</div>
            )}
          </Col>

          <Col md={6}>
            <Form.Group className="password-container">
              <div className="password-label">
                <Form.Label htmlFor="confirmPassword">
                  Confirm Password*
                </Form.Label>
                {/* <div className="password-icon">
                  <i
                    className={`eye-icon fas ${
                      passwordVisible ? "fa-eye-slash" : "fa-eye"
                    }`}
                    onClick={togglePasswordVisibility}
                  ></i>{" "}
                  <span
                    className="show-hide-text"
                    onClick={togglePasswordVisibility}
                  >
                    {passwordVisible ? "Hide" : "Show"}
                  </span>
                </div> */}
              </div>

              <Form.Control
                className="rounded-input"
                type={passwordVisible ? "text" : "password"}
                id="confirmPassword"
                value={userData["confirmPassword"]}
                onChange={(e) =>
                  setUserData({ ...userData, confirmPassword: e.target.value })
                }
              />
              {errors.confirmPassword && (
                <div className="error-message">{errors.confirmPassword}</div>
              )}
            </Form.Group>
          </Col>
           <div                     style={{marginTop:"8px"}}
>
                  {/* <i
                    className={`eye-icon fas ${
                      passwordVisible ? "fa-eye-slash" : "fa-eye"
                    }`}
                    onClick={togglePasswordVisibility}
                  ></i>{" "} */}
                  <span
                    className="show-hide-text"
                    style={{color:"#2563eb",fontWeight:700,fontSize:"14px",paddingTop:"8px"}}
                    onClick={togglePasswordVisibility}
                  >
                    {passwordVisible ? "Hide Password" : "Show Password"}
                  </span>
                </div>
        </Row>
      </div>
      
      {errors.passwordRegex && (
        <div className="error-message">{errors.passwordRegex}</div>
      )}{" "}
      <p className="terms-styling">
        By creating an account, you agree to the{" "}
        <span
          className="terms-link"
          style={{color:"#2563eb"}}
          onClick={() => handleShowModal("Terms and Conditions")}
        >
          Terms and Conditions
        </span>{" "}
        and{" "}
        <span
          className="terms-link"
                    style={{color:"#2563eb"}}

          onClick={() => handleShowModal(strings.modal.privacy)}
        >
          Privacy Policy
        </span>
      </p></div>
      <center>
        <div className="form-button">
          <button className="buttonForForm" onClick={handleSubmit} style={{ backgroundColor: userData["password"]&& userData["confirmPassword"]
      ? "#ffc85d"
      : "#eaeff9",
    cursor: userData["password"]&& userData["confirmPassword"]
      
      ? "pointer"
      : "not-allowed",
  }}>
            Next
          </button>
        </div>

        <p className="login-styling">
          Already have an Account?{" "}
          <span className="login-link"           style={{color:"#2563eb"}}
 onClick={() => navigate("/")}>
            Login
          </span>
        </p>
      </center>
      <GenericModal
        show={modalShow}
        handleClose={() => handleClose()}
        title={modalTitle}
        content={modalContent}
      />
    </div>
  );
};

export default ThirdStep;
